var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _defs2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketSilhouetteBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000113325662660998750520000008009787862404671377_);}\n\t.st1{opacity:0.26;}\n\t.st2{clip-path:url(#SVGID_00000114059655328974720460000003981374775130104501_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M900.94,987.91H236.76c-22.94,0-32-16.15-32-29.24l-1.49-144.7l14.96-223.01 c0-10.23,8.3-18.53,18.53-18.53h656.32c10.23,0,18.53,8.3,18.53,18.53l17.94,222.69v145.73 C929.55,973.37,919.45,987.91,900.94,987.91z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074416161414787053710000017717178788882896575_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 572.43,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 3.78
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 576.21,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 581.29,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 586.36,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 591.44,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 596.52,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 601.59,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 606.67,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 611.75,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 616.82,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 621.9,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 626.98,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 632.05,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 637.13,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 642.2,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 647.28,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 652.36,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 657.43,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 662.51,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 667.59,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 672.66,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 677.74,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 682.82,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 687.89,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 692.97,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 698.05,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 703.12,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 708.2,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 713.28,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 718.35,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 723.43,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 728.51,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 733.58,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 738.66,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 743.74,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 748.81,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 753.89,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 758.96,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 764.04,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 769.12,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 774.19,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 779.27,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 784.35,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 789.42,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 794.5,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 799.58,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 804.65,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 809.73,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 814.81,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 819.88,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 824.96,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 830.04,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 836.64,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 843.24,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 849.85,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 856.45,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 863.06,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 869.66,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 876.26,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 882.87,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 889.47,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 896.08,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 902.68,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 909.28,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 915.89,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 922.49,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 929.1,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 935.7,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 942.3,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 948.91,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 955.51,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 962.12,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 968.72,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 975.32,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 981.93,
    style: {
      clipPath: "url(#SVGID_00000074416161414787053710000017717178788882896575_)"
    },
    width: 726.28,
    height: 5.98
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "828.23,792.62 306.6,792.62 312.3,629.43 821.82,629.43  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "810.18,775.76 324.65,775.76 329.96,646.89 804.21,646.89  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M908.1,580.18c-3.31-4.68-8.78-7.75-15.05-7.75H236.76c-5.82,0-10.95,2.62-14.25,6.84c0,0,2.85-9.01,14.25-19.61l4.67-4.68 c7.18-6.95,16.76-10.95,26.79-11.06l227.58-1.71c-8.66,9.58-18.58,15.62-18.58,15.62s77.65,23.49,171.6,0 c0,0-10.6-6.39-19.38-16.65l233.17-1.71c9.81,0,19.27,3.65,26.45,10.38l5.93,5.47C894.99,555.32,909.47,570.37,908.1,580.18z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 908.1,
    y1: 580.29,
    x2: 908.1,
    y2: 580.18
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M648.83,557.83c-93.95,23.49-171.6,0-171.6,0s9.92-6.04,18.58-15.62c6.73-7.41,12.77-17.1,12.77-27.82 c0-24.63,6.5-87.34-17.45-116.87c-23.83-29.64-78.1-84.03-78.1-153.81c7.41-82.66,79.01-144.23,157.92-140.13 c73.31,3.76,135.34,63.51,142.07,140.13c0,69.78-54.27,124.17-78.1,153.81c-23.94,29.53-17.44,92.24-17.44,116.87 c0,10.15,5.47,19.5,11.97,26.79C638.22,551.45,648.83,557.83,648.83,557.83z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M900.94,987.91H236.76c-22.94,0-32-16.15-32-29.24l-1.49-144.7l14.96-223.01c0-10.23,8.3-18.53,18.53-18.53h656.32 c10.23,0,18.53,8.3,18.53,18.53l17.94,222.69v145.73C929.55,973.37,919.45,987.91,900.94,987.91z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "828.23,792.62 306.6,792.62 312.3,629.43 821.82,629.43  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "810.18,775.76 324.65,775.76 329.96,646.89 804.21,646.89  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M629.44,541.18l233.17-1.71c9.81,0,19.27,3.65,26.45,10.38l5.93,5.47c0,0,14.14,14.14,12.43,23.94"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M222.51,579.27c0,0,2.85-9.01,14.25-19.61l4.67-4.67c7.18-6.96,16.76-10.95,26.79-11.06l227.58-1.71"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M565.99,103.41c1.64,0.03,3.27,0.08,4.92,0.17c73.41,3.79,135.42,63.46,142.12,140.1c0,69.84-54.28,124.23-78.15,153.81 c-23.87,29.57-17.46,92.28-17.46,116.87c0,24.59,31.36,43.47,31.36,43.47"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M477.27,557.82c0,0,31.36-18.88,31.36-43.47c0-24.59,6.41-87.3-17.46-116.87c-23.87-29.57-78.15-83.97-78.15-153.81 c7.29-80.89,76.03-141.6,152.97-140.27"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M260.16,295.16c16.51,5.32,132.88,41.13,277.43,41.13c119.53,0,187.34-69.04,220.86-110.83 c-33.51-41.8-101.34-110.84-220.86-110.83c-144.55,0-260.92,35.79-277.43,41.11V295.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M603.15,85.14c-183.01,0-291.66,45.33-312.58,52.07V313.7c20.92,6.75,129.57,52.07,312.58,52.06 c80.66,0,156.6-24.83,216.4-56.03V141.17C759.75,109.97,683.81,85.14,603.15,85.14"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M931.71,225.45c-19.82-24.71-59.79-56.94-112.16-84.28l-0.01,168.57C871.92,282.4,911.89,250.16,931.71,225.45"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M209.66,155.21c-30.9,0.79-147.92,76.46-147.92,76.46c53.57,21.37,121.21,69.63,151.6,68.87 c30.4-0.76,72.69-35.93,71.71-74.52C284.08,187.41,240.59,154.42,209.66,155.21"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M465.67,135.58c0,0-27.22-47.56-75.4-71.04c-61.13-29.83-154.75-37.71-160.7-26.11c-5.96,11.61,39.07,25.63,65.47,49.02 c43.67,38.7,41.06,72.08,41.06,72.08L465.67,135.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.83,160.93l0.11-1.5c0.02-0.33,1.99-33.33-40.67-71.13c-11.27-9.99-25.84-18.18-38.68-25.4 c-17.97-10.1-30.95-17.4-27.04-25c6.7-13.1,103.47-3.08,162.22,25.6c47.95,23.37,75.63,71.03,75.9,71.5l0.81,1.41l-1.6,0.3 L334.83,160.93z M253.97,34.61c-13.21,0-21.93,1.54-23.37,4.35c-2.89,5.62,10.55,13.18,26.12,21.93 c12.95,7.29,27.64,15.53,39.09,25.68c38.97,34.54,41.47,64.57,41.48,71.56l126.54-23.38c-4.95-8.02-31.38-48.37-74.07-69.18 C344.99,43.73,286.16,34.61,253.97,34.61z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M465.67,315.26c0,0-27.23,47.55-75.4,71.05c-61.13,29.83-154.75,37.71-160.71,26.1c-5.95-11.6,39.07-25.62,65.47-49.02 c43.67-38.69,41.07-72.06,41.07-72.06L465.67,315.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.21,418.6c-14.09,0-23.71-1.86-25.67-5.67c-3.89-7.59,9.08-14.88,27.02-24.98c12.86-7.23,27.43-15.43,38.7-25.43 c42.66-37.78,40.71-70.77,40.68-71.1l-0.11-1.5l1.47,0.27l131.17,24.24l-0.81,1.41c-0.28,0.47-27.96,48.12-75.9,71.5 C349.15,407.66,288.46,418.6,254.21,418.6z M337.29,292.73c-0.01,6.97-2.52,37.01-41.49,71.53c-11.46,10.16-26.14,18.41-39.1,25.7 c-15.56,8.75-28.99,16.31-26.11,21.92c4.98,9.66,96.02,4.2,159.17-26.6c42.67-20.81,69.12-61.16,74.07-69.18L337.29,292.73z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M260.16,295.16c16.51,5.32,132.88,41.13,277.43,41.13c119.53,0,187.34-69.04,220.86-110.83 c-33.51-41.8-101.34-110.84-220.86-110.83c-144.55,0-260.92,35.79-277.43,41.11V295.16z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M603.15,85.14c-183.01,0-291.66,45.33-312.58,52.07V313.7c20.92,6.75,129.57,52.07,312.58,52.06 c80.66,0,156.6-24.83,216.4-56.03V141.17C759.75,109.97,683.81,85.14,603.15,85.14L603.15,85.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.09,366.91c-166.11,0-270.47-37.1-304.76-49.29c-3.45-1.23-6.16-2.19-8.1-2.82l-0.8-0.25V136.37l0.8-0.25 c1.95-0.63,4.67-1.6,8.15-2.83C332.69,121.09,437.1,84,603.16,84c90.34,0,167.83,30.54,216.92,56.15l0.62,0.33v169.96l-0.62,0.33 c-49.11,25.61-126.61,56.15-216.92,56.15C603.13,366.91,603.11,366.91,603.09,366.91z M291.72,312.87c1.88,0.62,4.34,1.5,7.37,2.58 c34.21,12.16,138.31,49.17,304,49.17c0.03,0,0.03,0,0.07,0c89.47,0,166.32-30.14,215.24-55.58V141.87 c-48.91-25.43-125.74-55.58-215.24-55.58c-165.66,0-269.79,37.01-304.01,49.17c-3.06,1.08-5.53,1.96-7.42,2.59V312.87z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M931.71,225.45c-19.82-24.71-59.79-56.94-112.16-84.28l-0.01,168.57C871.92,282.4,911.89,250.16,931.71,225.45 L931.71,225.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.4,311.63l0.01-172.36l1.68,0.88c48.13,25.14,90.2,56.76,112.53,84.59l0.57,0.72l-0.57,0.72 c-22.33,27.84-64.39,59.46-112.54,84.59L818.4,311.63z M820.7,143.07l-0.01,164.76c46.75-24.62,87.52-55.27,109.53-82.38 C908.21,198.35,867.45,167.7,820.7,143.07z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M444.08,225.84v-0.06v-0.03c0-11.9-18.45-19.84-43.19-19.84c-24.73-0.01-171.86,2.65-171.86,19.84v0.03 c0,0.02,0,0.03,0,0.06c0,17.18,147.12,19.83,171.86,19.83C425.64,245.67,444.08,237.74,444.08,225.84L444.08,225.84z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000075143460652681177610000008406424713304937602_",
    x: 229.02,
    y: 225.79,
    width: 215.06,
    height: 19.88
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075143460652681177610000008406424713304937602_",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000159446847142312418090000007479423522487411089_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075143460652681177610000008406424713304937602_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000159446847142312418090000007479423522487411089_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M444.08,225.84v-0.06H229.03c0,0.02,0,0.03,0,0.06c0,17.18,147.12,19.83,171.86,19.83 C425.64,245.67,444.08,237.74,444.08,225.84"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketSilhouetteBlack);
export default __webpack_public_path__ + "static/media/rocket-silhouette-black.96bffc6b6094d4b3c9de0068ee73f390.svg";
export { ForwardRef as ReactComponent };